/* ===== Score History Chart ===== */

.wrapper {
  padding: 14px 20px;
  border-bottom: 1px solid var(--box-border-color, #e5e7eb);
}

.label {
  font-size: 0.6rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--secondary-text, #9ca3af);
  margin: 0 0 8px 0;
}

.svg {
  width: 100%;
  height: auto;
  display: block;
}

.axisLabel {
  font-size: 10px;
  fill: var(--secondary-text, #b0b5be);
  font-weight: 600;
  font-family: inherit;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.dateLabel {
  font-size: 10px;
  fill: var(--secondary-text, #9ca3af);
  font-weight: 500;
  font-family: inherit;
}

/* Loading */
.loadingPlaceholder {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed var(--box-border-color, #e5e7eb);
  border-radius: 6px;
  background: var(--light-grey, #f9fafb);
}

.loadingText {
  font-size: 0.72rem;
  color: var(--secondary-text, #9ca3af);
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
}

/* Single point fallback */
.singlePoint {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: var(--light-grey, #f9fafb);
  border-radius: 6px;
  border: 1px solid var(--box-border-color, #e5e7eb);
}

.singleDot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

.singleText {
  font-size: 0.75rem;
  color: var(--secondary-text, #6b7280);
  font-weight: 500;
}
